// extracted by mini-css-extract-plugin
export default {"button":"PdfButton_button__KyWeN","button_mini":"PdfButton_button_mini__11wMX"};